import { useExpiryDateString } from "features/Common/modules/DateTime/hooks/useExpiryDateString";

export const useUpdateExpiryModal = ({
  open,
  endDate,
  startDate,
  showStartDate,
}) => {
  const {
    dateString: expiry_date,
    toPickerDate,
    handleDateChange: handleExpiryDateChange,
  } = useExpiryDateString({ open, initialDate: endDate });

  const { dateString: start_date, handleDateChange: handleStartDateChange } =
    useExpiryDateString({
      open: open && showStartDate,
      initialDate: startDate,
    });

  return {
    expiry_date,
    start_date,
    toPickerDate,
    handleExpiryDateChange,
    handleStartDateChange,
  };
};
